import React from 'react';
import { Card, CardContent } from '../ui/card';
import * as Icons from 'lucide-react';
import { cn } from '@/lib/utils';
import { useLanguage } from '../../context/LanguageContext';

export const ServiceCard = ({ service, variant = 'default' }) => {
  const { t } = useLanguage();
  const IconComponent = Icons[service.icon] || Icons.Box;
  
  // Map service IDs to translation keys
  const serviceIdMap = {
    'co-reg': 'coReg',
    'co-spo': 'coSpo',
    'email': 'email',
    'sms': 'sms',
    'sweepstakes': 'leadAcquisition',
    'phone': 'phone',
    'data': 'data',
    'api': 'api'
  };
  
  // Get translated service data
  const serviceKey = serviceIdMap[service.id] || service.id;
  const translatedService = t.services.items[serviceKey] || { title: service.title, shortDesc: service.shortDesc, fullDesc: service.fullDesc };
  
  if (variant === 'detailed') {
    return (
      <Card className="group bg-white dark:bg-slate-800/50 border-slate-200 dark:border-slate-700/50 hover:border-emerald-300 dark:hover:border-emerald-700 hover:shadow-xl hover:shadow-emerald-500/5 transition-all duration-300">
        <CardContent className="p-8">
          <div className="flex items-start gap-6">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center flex-shrink-0 shadow-lg shadow-emerald-500/20 group-hover:shadow-emerald-500/30 transition-shadow duration-300">
              <IconComponent className="w-7 h-7 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-2">
                {translatedService.title}
              </h3>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                {translatedService.fullDesc}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="group bg-white dark:bg-slate-800/50 border-slate-200 dark:border-slate-700/50 hover:border-emerald-300 dark:hover:border-emerald-700 hover:shadow-xl hover:shadow-emerald-500/5 transition-all duration-300 h-full">
      <CardContent className="p-6">
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center mb-4 shadow-lg shadow-emerald-500/20 group-hover:shadow-emerald-500/30 transition-shadow duration-300">
          <IconComponent className="w-6 h-6 text-white" />
        </div>
        <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
          {translatedService.title}
        </h3>
        <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
          {translatedService.shortDesc}
        </p>
      </CardContent>
    </Card>
  );
};
